export default {
  '0001': 'El enlace ha expirado, por favor inicie sesión e intente descargar el archivo nuevamente',
  'SUBTITLE': 'Ingresa con las mismas credenciales de tu cuenta de Aruba Central. En caso de no recordarlas, o aún no cuentes con ellas  comunícate al 800 123 9434',
  'LOGIN_PLACEHOLDER': 'Correo Electrónico',
  'PASSWORD': 'Contraseña',
  'REMEMBER': 'Recordarme por 7 días',
  'SUBMIT_BUTTON': 'Iniciar sesión',
  'VERSION': `Versión ${process.env.REACT_APP_VERSION}`
}
